import axios from 'axios';
import { ITariffEditProps } from '../interfaces/tariff';
import { UserRoles } from '../interfaces/user';

export const getTariffs = (role?: UserRoles) => {
  if(role){
    return axios.get(`/api/tariffs?role=${role}`);
  }
  return axios.get(`/api/tariffs`);
};

export const editTariff = (id: number, data: ITariffEditProps) =>
  axios.put(`api/tariff/${id}`, data);

export const getTariffById = (id: number) => axios.get(`api/tariff/${id}`);

export const buyTariffGem = async (id: number, days: number) =>
  axios.post(`/api/buy_tariff/${id}?days=${days}`);

